import { render, staticRenderFns } from "./TagListByCategory.vue?vue&type=template&id=67154ca7"
import script from "./TagListByCategory.vue?vue&type=script&lang=js"
export * from "./TagListByCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports